import { dbPromise } from "../db";

export type WithID<T> = T & { id: IDBValidKey };

export async function getAll<T>(store: string): Promise<WithID<T>[]> {
  const db = await dbPromise;
  return db.getAll(store) as Promise<WithID<T>[]>;
}

export async function add<T extends object>(
  store: string,
  data: T
): Promise<WithID<T>> {
  const db = await dbPromise;
  const id = await db.add(store, data);
  return { ...data, id };
}

export async function remove(
  store: string,
  id: IDBValidKey
): Promise<void> {
  const db = await dbPromise;
  await db.delete(store, id);
}